import { Percent } from '@uniswap/sdk-core'

import { SupportedChainId } from './chains'

export const INTERFACE_FEE_RECIPIENT = {
  [SupportedChainId.DUCX_TESTNET]: '0x818664bBe2913b7cCED71352F6912CcC0e376880',
  [SupportedChainId.DUCX]: '0x36400517548EDc3D1c379057A8edaD9Ed9Bda5A1',
}

export const INTERFACE_FEE_PERCENT = new Percent(300, 10000) // 1%

export const INTERFACE_FEE_ENABLED = true
